import React from 'react';
import { Phone, Mail, MapPin, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Topbar() {
  return (
    <div className="bg-[#0073A5] text-white text-xs py-2 px-4 sm:px-6 lg:px-12">
      <div className="max-w-[1600px] mx-auto flex items-center justify-between">
        {/* Left: Flags/Language */}
        <div className="flex items-center space-x-3">
          <a 
            href="https://www.facebook.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:opacity-80 cursor-pointer transition-opacity text-white flex items-center pr-1"
            title="Følg os på Facebook"
          >
            <Facebook className="w-4 h-4 fill-white stroke-none" />
          </a>
          <Link to="/" className="hover:opacity-80 cursor-pointer transition-opacity text-base" title="Dansk">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 28" className="w-5 h-3.5 rounded-xs shadow-xs object-cover inline-block">
              <rect width="37" height="28" fill="#C60C30"/>
              <rect x="12" width="4" height="28" fill="#ffffff"/>
              <rect y="12" width="37" height="4" fill="#ffffff"/>
            </svg>
          </Link>
          <Link to="/information-in-english" className="hover:opacity-80 cursor-pointer transition-opacity text-base" title="English">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" className="w-5 h-3.5 rounded-xs shadow-xs object-cover inline-block">
              <clipPath id="s">
                <path d="M0,0 v30 h60 v-30 z"/>
              </clipPath>
              <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
              <path d="M0,0 L60,30 M60,0 L0,30" stroke="#ffffff" strokeWidth="6"/>
              <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" clipPath="url(#s)"/>
              <path d="M30,0 v30 M0,15 h60" stroke="#ffffff" strokeWidth="10"/>
              <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
            </svg>
          </Link>
        </div>
        
        {/* Right: Contact Quick Info */}
        <div className="flex items-center space-x-6 font-semibold">
          <span className="hidden md:inline-flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 text-sky-200" />
            <span>Kurkmarkvej 6, 6093 Sjølund</span>
          </span>
          <a 
            href="tel:+4576991020" 
            className="hover:text-sky-100 transition-colors whitespace-nowrap"
          >
            (+45) 76 99 10 20
          </a>
          <a 
            href="mailto:info@dan-team.com" 
            className="hover:text-sky-100 transition-colors whitespace-nowrap hidden sm:inline"
          >
            info@dan-team.com
          </a>
        </div>
      </div>
    </div>
  );
}
